module.exports = __webpack_public_path__ + "static/media/ramestta-logo.3be053c6.png";